import React from "react";

const PaperBG = ({ children, className = "", fullHeight = false }) => {
  return (
    <div
        className={`${fullHeight ? "min-h-screen" : ""} w-full text-gray-900 ${className}`}
        style={{
        backgroundColor: "#fdfdfb",
        backgroundImage: `
          radial-gradient(#f0f0ee 1px, transparent 1px),
          radial-gradient(#e7e7e2 1px, transparent 1px)
        `,
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 10px 10px",
        boxShadow: "inset 0 0 60px rgba(0, 0, 0, 0.02)",
      }}
    >
      {children}
    </div>
  );
};

export default PaperBG;

